import { ReloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { dynamicRoutes } from '../../../../../constants/routes'
import qs from 'qs'

interface ReorderProps {
    stampOrderDocId: string
}

const Reorder: FC<ReorderProps> = ({ stampOrderDocId }) => {
    return (
        <Link
            to={dynamicRoutes.purchasesStampOrdersNewByCopy(
                qs.stringify({ copyBy: stampOrderDocId })
            )}
        >
            <Button size={'small'} icon={<ReloadOutlined />} title={'Повторить заказ'} />
        </Link>
    )
}

export default Reorder
